import * as SuppliersModule from '../../redux/modules/supplier';

import { RootState } from '../../redux/modules';
import AdditionalContacts, {
  AdditionalContatctsProps,
} from '../../components/UI/additional-contact/additioal-contact-form';
import Button from '../../ui_components/button/button';
import Checkbox from '../../ui_components/checkbox/checkbox';
import { PopoverScrollContext } from '../../ui_components/popover/popover';
import TextArea from '../../ui_components/textArea/textArea';
import ValidationForm from '../../ui_components/validation/validationForm';
import { ValidationPopupInput } from '../../ui_components/validation/validationPopupInput';
import { Modal, ModalActions, ModalContent, ModalHeader } from '../../ui_components/modal';
import PageDimmer from '../../ui_components/dimmer/PageDimmer';
import { DispatchProp, connect } from 'react-redux';
import React, { ChangeEvent, FormEvent, KeyboardEvent, PureComponent, UIEvent } from 'react';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import styled, { theme } from '../../theme';

import { AvatarModal } from '../../modals/avatar_modal';
import BillingInfo from './supplier-billing-info';
import OrderingInfo from './supplier-ordering-info';
import { detect } from 'detect-browser';
import { formatPhoneNumber } from '../../utils/phone';
import { uploadImage } from '../../api/account';
import { Config } from '../../utils';
import { MixpanelEvents } from '../../components/analytics/mix_panel_events';
import { trackView } from '../../components/analytics/track_view';

const noop = () => {
  return;
};

// this shit is losing the original classname when using styled()
const TabContainer = styled(TabPanel).attrs({
  className: 'react-tabs__tab-panel',
})`
  height: 518px !important;
  overflow: auto !important;
  flex: 1 auto !important;
`;

export const SupplierBlock = styled.div`
  display: flex !important;
  width: 100% !important;
  flex-wrap: wrap !important;
  align-items: flex-start !important;
  min-height: inherit !important;

  > div {
    margin-bottom: 11px !important;
    margin-top: 20px;
  }

  .label {
    width: 100% !important;
    border-radius: 0.5em !important;
  }

  .text-area {
    width: 600px !important;
    height: 200px !important;
    margin-top: 15px !important;
    border: 1px solid #d2d8dd !important;
    border-radius: 0 !important;
    box-shadow: 4px 4px 4px 1px #c1c2c3 !important;
    padding: 2.5em 1.5em !important;

    &::placeholder {
      color: #338daa !important;
    }
  }
`;

export const LeftCell = styled.div`
  width: 50% !important;
  margin-bottom: 20px !important;
  padding-right: 1.25rem !important;
`;

export const RightCell = styled(LeftCell)`
  padding-right: 0 !important;
  padding-left: 1.25rem !important;
`;

export const RightCellWithBorder = styled(RightCell)`
  border-left: 1px solid #338daa !important;
`;

export const SupplierSubtitle = styled.h4`
  color: #338daa !important;
  font-weight: bold !important;
  letter-spacing: 1.5px !important;
  margin-top: 0 !important;
`;

export const SupplierLabel = styled.label`
  color: ${theme.colors.grayRGBA} !important;
`;

export const TwoItemsWrapper = styled.div`
  display: flex !important;
  justify-content: space-between !important;
  margin-bottom: 8px !important;

  > div {
    width: 48% !important;
  }
`;

export const ThreeItemsWrapper = styled(TwoItemsWrapper)`
  margin-bottom: 8px !important;
  > div:nth-child(1) {
    width: 48% !important;
  }

  > div:nth-child(2) {
    width: 17% !important;
  }

  > div:nth-child(3) {
    width: 27% !important;
  }
`;

const ModalForm = styled(ValidationForm)`
  height: 100% !important;
  min-height: inherit !important;
`;

export const AdditionalForm = styled(ValidationForm)`
  display: flex !important;
  flex-wrap: wrap !important;
  padding-left: 2rem !important;
  margin-top: 20px;
  flex-direction: row !important;

  ${ThreeItemsWrapper} {
    > div:nth-child(1) {
      width: 36% !important;
    }

    > div:nth-child(2) {
      width: 26% !important;
    }

    > div:nth-child(3) {
      width: 27% !important;
    }
  }
`;

const AdditionalContactsMessage = styled.div`
  font-size: 16px;
  color: red;
  text-align: center;
`;

const ModalContainer = styled(Modal)`
  width: 90%;
  min-height: 300px;
  bottom: 0;
`;

const ModalHeaderSupplier = styled(ModalHeader)`
  border-bottom: none;
  padding-bottom: 0 !important;

  div {
    width: 100%;
    border-bottom: 10px solid #e6f1f4;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 0.5rem;
  }

  .modal-title {
    font-size: 26px !important;
  }
`;

export const SupplierFormInput = styled(ValidationPopupInput as any)`
  padding: 0.35em 0.5em !important;
`;

export const SupplierCheckbox = styled(Checkbox)`
  color: ${theme.colors.grayRGBA} !important;
  font-size: 0.85em !important;
`;

export const SupplierCheckboxSmall = styled(SupplierCheckbox)`
  font-size: 1em !important;
`;

const ModalContentSupplier = styled(ModalContent)`
  display: flex !important;
  flex-direction: column !important;
  height: 100% !important;
  min-height: inherit !important;

  .react-tabs__tab-list {
    border-bottom: 6px solid #338daa !important;
    margin-bottom: 0 !important;
  }

  .react-tabs__tab {
    margin-right: 10px !important;
    border-radius: 5px 5px 0 0 !important;
    border: 1px solid #aaa !important;
    border-bottom: none !important;
    bottom: 0 !important;
    background-color: white !important;
    color: ${theme.colors.grayRGBA} !important;

    &:last-child {
      margin-right: 0 !important;
    }
  }

  .react-tabs__tab-panel {
    flex: 1 !important;
  }

  .react-tabs__tab--selected {
    background-color: #338daa !important;
    color: #fff !important;
    border-color: transparent !important;

    &:focus {
      outline: none !important;
    }
  }

  .react-tabs__tab-panel--selected {
    margin-top: 0 !important;
    display: flex !important;
    flex-direction: column !important;
  }

  .react-tabs__tab:focus {
    box-shadow: none !important;
  }

  .react-tabs__tab:focus::after {
    position: relative !important;
  }
`;

export const ModalTabs = styled(Tabs)`
  flex: 1 !important;
  display: flex !important;
  flex-direction: column !important;
  height: 100% !important;
  min-height: inherit !important;
`;

const FormErrors = styled.div`
  color: #82848b !important;
  overflow: hidden !important;
  background-color: #f8d7da !important;
  border-color: #f5c6cb !important;
  margin-bottom: 5px !important;
`;

const FormError = styled.div`
  margin: 5px !important;
`;

export const SaveButton = styled(Button)`
  box-shadow: none !important;
  display: block !important;
`;

export const CancelButton = styled(Button)`
  margin-right: auto !important;
  box-shadow: none !important;

  &:hover {
    background-color: #eeeeee !important;
  }
`;

export const AddButton = styled(SaveButton)`
  width: 115px !important;
  margin: auto auto 0 auto !important;
`;

export const DisableAutocompleteInput = styled.input`
  display: none !important;
`;

const NameSeperator = styled.span`
  font-size: 24px !important;
  font-weight: 400 !important;
  color: #9e999f !important;
  padding: 0 10px !important;
`;

const Name = styled.a`
  color: #51a6c5 !important;
  font-size: 20px !important;
  flex: 1 !important;
`;

const shippingAddressDefault = (): SuppliersModule.SupplierAdditionalContact => ({
  id: 0,
  accountNumber: '',
  cellPhone: '',
  cityTown: '',
  company: '',
  country: '',
  email: '',
  fax: '',
  firstName: '',
  homePhone: '',
  lastName: '',
  mainPhone: '',
  officePhone: '',
  paymentTerms: '',
  relation: '',
  stateProvince: '',
  streetAddress: '',
  unitSuite: '',
  website: '',
  zipCode: '',
});
const billingAddressDefault = (): SuppliersModule.SupplierAdditionalContact => ({
  id: 0,
  accountNumber: '',
  cellPhone: '',
  cityTown: '',
  company: '',
  country: '',
  email: '',
  fax: '',
  firstName: '',
  homePhone: '',
  lastName: '',
  mainPhone: '',
  officePhone: '',
  paymentTerms: '',
  relation: '',
  stateProvince: '',
  streetAddress: '',
  unitSuite: '',
  website: '',
  zipCode: '',
});

const supplierDefaults = (): SuppliersModule.Supplier => ({
  id: 0,
  active: true,
  avatarId: '',
  accountNumber: '',
  mainPhone: '',
  displayName: '',
  companyName: '',
  fax: '',
  notes: '',
  tags: '',
  type: 'installer',
  shippingAddress: shippingAddressDefault(),
  billingAddress: billingAddressDefault(),
  additionalContacts: [],
});

interface AddSupplierProps {
  isModalOpen: boolean;
  resetOnClose: boolean;
  accountId: number;
  initialValues?: SuppliersModule.Supplier;
  onSave(supplier: SuppliersModule.Supplier): Promise<void>;
  onModalClose(): void;
  setFocusFirstField?(fn: any): void;
  isUnique?: boolean;
  triggerFieldFocus?: boolean;
  handleChangeUniqueName?(): void;
  style?: any;
}

interface State {
  fields: SuppliersModule.Supplier;
  formErrors: string[];
  tabIndex: number;
  imageModalOpen: boolean;
  isSameOrderingInfo: boolean;
  areaScrollInfo: {
    scrollX: number;
    scrollY: number;
  };
  isCustomDisplayName: boolean;
  stateList: string[];
  additionalFormOpen: boolean;
  isOpen: boolean;
  customSupplier?: boolean;
}

export class SupplierModal extends PureComponent<AddSupplierProps & DispatchProp, State> {
  private orderingInfoRef = React.createRef<OrderingInfo>();

  public constructor(props: AddSupplierProps & DispatchProp) {
    super(props);

    const { initialValues } = this.props;
    const stateList: string[] = [
      'AL',
      'AK',
      'AZ',
      'AR',
      'CA',
      'CO',
      'CT',
      'DE',
      'DC',
      'DR',
      'FL',
      'GA',
      'HI',
      'ID',
      'IL',
      'IN',
      'IA',
      'KS',
      'KY',
      'LA',
      'ME',
      'MT',
      'NE',
      'NV',
      'NH',
      'NJ',
      'NM',
      'NY',
      'NC',
      'ND',
      'OH',
      'OK',
      'OR',
      'MD',
      'MA',
      'MI',
      'MN',
      'MS',
      'MO',
      'PA',
      'RI',
      'SC',
      'SD',
      'TN',
      'TX',
      'UT',
      'VT',
      'VA',
      'WA',
      'WV',
      'WI',
      'WY',
    ];
    const sortedStateList = stateList.sort((a: string, b: string) => (a > b ? 1 : -1));

    this.state = {
      fields: initialValues
        ? {
            ...initialValues,
            additionalContacts: [...initialValues.additionalContacts],
            billingAddress: {
              ...initialValues.billingAddress,
            },
            shippingAddress: {
              ...initialValues.shippingAddress,
            },
          }
        : supplierDefaults(),
      isOpen: false,
      formErrors: [],
      tabIndex: 0,
      imageModalOpen: false,
      areaScrollInfo: {
        scrollX: 0,
        scrollY: 0,
      },
      isCustomDisplayName: false,
      isSameOrderingInfo: false,
      stateList: sortedStateList,
      additionalFormOpen: false,
      customSupplier: initialValues && initialValues.customSupplier,
    };
  }

  public componentDidMount() {
    if (this.props.isModalOpen) {
      trackView(MixpanelEvents.CLIENT_DETAILS_PROFILE, {});
      if (this.state.tabIndex === 0) {
        trackView(MixpanelEvents.CLIENT_PROFILE_INFO, {});
      }
    }

    if (this.props.setFocusFirstField) {
      this.props.setFocusFirstField(this.setFocusOnFirstField);
    }
  }

  public componentDidUpdate(prevProps: any, prevState: any): void {
    if (prevProps.initialValues !== this.props.initialValues) {
      this.setState((prev) => {
        return {
          ...prev,
          fields: this.props.initialValues
            ? {
                ...this.props.initialValues,
                additionalContacts: [...this.props.initialValues.additionalContacts],
                billingAddress: {
                  ...this.props.initialValues.billingAddress,
                },
                shippingAddress: {
                  ...this.props.initialValues.shippingAddress,
                },
              }
            : supplierDefaults(),
        };
      });
    }

    if (prevProps.triggerFieldFocus !== this.props.triggerFieldFocus) {
      this.setState((prev) => ({ ...prev, tabIndex: 0 }));
    }

    if (prevProps.isModalOpen !== this.props.isModalOpen && this.props.isModalOpen) {
      trackView(MixpanelEvents.SUPPLIER_PROFILE);
      if (this.state.tabIndex === 0) {
        trackView(MixpanelEvents.SUPPLIER_PROFILE_INFO, {});
      }
    }

    if (prevState.tabIndex !== this.state.tabIndex) {
      const index_view_relation: any = {
        '0': MixpanelEvents.SUPPLIER_PROFILE_INFO,
        '1': MixpanelEvents.SUPPLIER_PROFILE_BILLING,
        '2': MixpanelEvents.SUPPLIER_PROFILE_CONTACTS,
        '3': MixpanelEvents.SUPPLIER_PROFILE_NOTES,
      };
      trackView(index_view_relation[this.state.tabIndex], {});
    }
  }

  public setFocusOnFirstField = () => {
    if (this.orderingInfoRef.current) {
      this.orderingInfoRef.current.setFocusOnFirstField();
    }
  };

  public render(): JSX.Element {
    const { fields } = this.state;

    return (
      <>
        <PageDimmer uiActive={this.props.isModalOpen} />
        <AvatarModal
          uiActive={this.state.imageModalOpen}
          uiOnRequestClose={this.closeAvatarModal}
          onSave={this.saveAvatarImage}
        />
        <ModalContainer
          uiActive={this.props.isModalOpen}
          uiOnRequestClose={noop}
          uiDefaultSizes={false}
          style={this.props.style || {}}
        >
          <ModalForm
            id="supplier"
            uiOnSubmit={this.submitForm}
            uiPadding={false}
            uiReportValidityMode="firstInvalid"
            uiOnInvalidElem={this.handleInvalidElem}
            onKeyPress={this.handleKeyPressForm}
          >
            <DisableAutocompleteInput name="firstName" />
            <ModalHeaderSupplier>
              <div>
                <span className="modal_title">Supplier Profile</span>
                {this.state.fields.displayName && (
                  <>
                    <NameSeperator> - </NameSeperator>
                    <Name>{`${this.state.fields.displayName}`}</Name>
                  </>
                )}
                <SupplierCheckbox
                  checked={!fields.active}
                  onClick={this.handleChangeInactiveSupplier}
                >
                  Make Inactive
                </SupplierCheckbox>
              </div>
            </ModalHeaderSupplier>
            <ModalContentSupplier>
              <FormErrors>
                {this.state.formErrors.map((error) => (
                  <FormError>{error}</FormError>
                ))}
              </FormErrors>

              <PopoverScrollContext.Provider value={this.state.areaScrollInfo}>
                <ModalTabs
                  selectedIndex={this.state.tabIndex}
                  onSelect={this.selectTab}
                  forceRenderTabPanel
                >
                  <TabList>
                    <Tab>Ordering Info</Tab>
                    <Tab>Billing Info</Tab>
                    <Tab>Additional Contacts</Tab>
                    <Tab>Notes</Tab>
                  </TabList>
                  {this.renderOrderingInfo()}

                  {this.renderBillingInfo()}

                  {this.renderAdditionalContactInfo()}

                  {this.renderNotes()}
                  <AdditionalContactsMessage>
                    {this.state.isOpen ? 'Please save or close "Additional Contacts" form' : ''}
                  </AdditionalContactsMessage>
                </ModalTabs>
              </PopoverScrollContext.Provider>
            </ModalContentSupplier>

            <ModalActions>
              <CancelButton
                className="cancel_btn"
                type="button"
                uiColor="secondary"
                onClick={this.closeModal}
              >
                Cancel
              </CancelButton>

              <SaveButton
                className="primary_btn"
                type="submit"
                uiColor="primary"
                disabled={this.state.additionalFormOpen}
                uiDisabled={this.state.additionalFormOpen}
              >
                Save
              </SaveButton>
            </ModalActions>
          </ModalForm>
        </ModalContainer>
      </>
    );
  }

  public renderOrderingInfo(): JSX.Element {
    return (
      <TabContainer onScroll={this.onTabAreaScoll}>
        <OrderingInfo
          ref={this.orderingInfoRef}
          formFields={this.state.fields}
          openAvatarModal={this.openAvatarModal}
          deleteAvatarImage={this.deleteAvatarImage}
          onSelectChange={this.handleSelectChange}
          onInputChange={this.handleInputChange}
          stateList={this.state.stateList}
          tags={this.state.fields.tags}
          onTagsChanged={this.onTagsChanged}
          handleChangeDisplayName={this.handleChangeDisplayName}
          isUnique={this.props.isUnique}
        />
      </TabContainer>
    );
  }

  public renderBillingInfo(): JSX.Element {
    return (
      <TabContainer onScroll={this.onTabAreaScoll}>
        <BillingInfo
          formFields={this.state.fields}
          stateList={this.state.stateList}
          onSelectChange={this.handleSelectChange}
          onInputChange={this.handleInputChange}
          handleChangeSameInformationCheckbox={this.handleChangeSameInformationCheckbox}
          isSameInfo={this.state.isSameOrderingInfo}
        />
      </TabContainer>
    );
  }

  public renderAdditionalContactInfo(): JSX.Element {
    return (
      <TabContainer onScroll={this.onTabAreaScoll}>
        <AdditionalContacts
          contacts={this.state.fields.additionalContacts}
          stateList={this.state.stateList}
          additionalFormOpen={this.state.additionalFormOpen}
          onAdditionalContactsChanged={this.changeAdditionalContacts}
          deleteContact={this.deleteAdditionalContact}
          setAdditionalFormStatus={this.setAdditionalFormStatus}
          updateParentState={this.updateParentState}
        />
      </TabContainer>
    );
  }

  public renderNotes(): JSX.Element {
    const browser = detect();
    return (
      <TabContainer onScroll={this.onTabAreaScoll}>
        <SupplierBlock>
          <div>
            <TextArea
              name="notes"
              placeholder="NOTES"
              onChange={this.handleInputChange}
              value={this.state.fields.notes}
              autoComplete={browser && browser.name === 'chrome' ? 'new-password' : 'off'}
            />
          </div>
        </SupplierBlock>
      </TabContainer>
    );
  }

  public selectTab = (index: number) => {
    this.setState({
      tabIndex: index,
      areaScrollInfo: {
        scrollX: 0,
        scrollY: 0,
      },
    });
  };

  private onTagsChanged = (newTags: string) => {
    this.setState({
      fields: {
        ...this.state.fields,
        tags: newTags,
      },
    });
  };

  private onTabAreaScoll = (e: UIEvent<HTMLDivElement>) => {
    const { scrollTop } = e.currentTarget;
    this.setState({
      areaScrollInfo: {
        scrollX: 0,
        scrollY: scrollTop,
      },
    });
  };

  private closeModal = () => {
    if (this.state.additionalFormOpen) {
      this.setState({ isOpen: true });
      return;
    }
    if (this.props.resetOnClose) {
      const { initialValues } = this.props;

      let fields: SuppliersModule.Supplier;
      if (initialValues) {
        fields = {
          ...initialValues,
          additionalContacts: [...initialValues.additionalContacts],
          billingAddress: {
            ...initialValues.billingAddress,
          },
          shippingAddress: {
            ...initialValues.shippingAddress,
          },
        };
      } else {
        fields = supplierDefaults();
      }

      this.setState({
        fields,
        formErrors: [],
        tabIndex: 0,
        imageModalOpen: false,
        areaScrollInfo: {
          scrollX: 0,
          scrollY: 0,
        },
        isSameOrderingInfo: false,
        isCustomDisplayName: false,
      });
    }
    this.props.onModalClose();
  };

  private handleSelectChange = (value: string, name: string) => {
    this.procesChange(value, name);
  };

  private handleInputChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    this.procesChange(e.currentTarget.value, e.currentTarget.name);
    if (this.props.handleChangeUniqueName) {
      this.props.handleChangeUniqueName();
    }
  };

  private changeAdditionalContacts: AdditionalContatctsProps['onAdditionalContactsChanged'] = (
    contacts
  ) => {
    this.setState({
      fields: {
        ...this.state.fields,
        additionalContacts: contacts,
      },
      additionalFormOpen: false,
    });
  };

  private procesChange = (value: string, name: string) => {
    if (!name) {
      return;
    }
    const newFields: SuppliersModule.Supplier = {
      ...this.state.fields,
      shippingAddress: {
        ...this.state.fields.shippingAddress,
      },
      billingAddress: {
        ...this.state.fields.billingAddress,
      },
    };
    let finalValue = value;
    let finalKey = name;
    let field: any = newFields;
    if (name.endsWith('Phone')) {
      finalValue = formatPhoneNumber(value);
    }
    if (name === 'companyName' && !this.state.isCustomDisplayName && !this.state.customSupplier) {
      field.displayName = finalValue;
    }

    if (name.startsWith('shippingAddress.')) {
      field = newFields.shippingAddress;
      finalKey = name.split('.').pop()!;
    } else if (name.startsWith('billingAddress.')) {
      field = newFields.billingAddress;
      finalKey = name.split('.').pop()!;
    }
    field[finalKey] = finalValue;

    this.setState({
      fields: newFields,
    });
  };

  private submitForm = async (e: FormEvent<HTMLFormElement>) => {
    const { fields } = this.state;
    const { onSave } = this.props;
    await onSave(fields);

    if (typeof window !== 'undefined' && 'BroadcastChannel' in window) {
      const channel = new BroadcastChannel('supplier-events');

      channel.postMessage({
        type: 'SUPPLIER_UPDATED',
        supplier: fields,
      });

      channel.close();
    }

    this.closeModal();
  };

  private handleChangeInactiveSupplier = () => {
    this.setState({
      fields: {
        ...this.state.fields,
        active: !this.state.fields.active,
      },
    });
  };

  private closeAvatarModal = () => {
    this.setState({
      imageModalOpen: false,
    });
  };

  private saveAvatarImage = async (file: File) => {
    if (file.size > 2 * 1024 * 1024) {
      try {
        file = await this.compressImage(file);
      } catch (error) {
        throw new Error('An error occurred while compressing the image.');
      }
    }
    const { accountId } = this.props;
    const formData = new FormData();
    formData.append('file', file);
    formData.append('accountId', accountId.toString());
    formData.append('fileStoreUrl', Config.fileStoreUrl);
    const res = await uploadImage(formData);
    if (res.error) {
      throw new Error(res.message);
    }
    this.setState({
      fields: {
        ...this.state.fields,
        avatarId: res.url,
      },
      imageModalOpen: false,
    });
  };

  private compressImage = (file: File): Promise<File> => {
    return new Promise((resolve) => {
      const reader = new FileReader();

      reader.onload = (event) => {
        const target = event.target as FileReader;
        if (!target || !target.result) return;
        const img = new Image();
        img.src = target.result as string;
        img.onload = () => {
          const maxWidth = 1024;
          const maxHeight = 1024;
          let width = img.width;
          let height = img.height;

          if (width > maxWidth || height > maxHeight) {
            const aspectRatio = width / height;
            if (width > height) {
              width = maxWidth;
              height = width / aspectRatio;
            } else {
              height = maxHeight;
              width = height * aspectRatio;
            }
          }

          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          if (!ctx) {
            resolve(file);
            return;
          }

          canvas.width = width;
          canvas.height = height;

          ctx.drawImage(img, 0, 0, width, height);

          canvas.toBlob(
            (blob) => {
              if (!blob) {
                resolve(file);
                return;
              }
              const compressedFile = new File([blob], file.name, {
                type: file.type,
                lastModified: file.lastModified,
              });
              resolve(compressedFile);
            },
            'image/jpeg',
            0.7
          );
        };
      };

      reader.readAsDataURL(file);
    });
  };

  private openAvatarModal = () => {
    this.setState({
      imageModalOpen: true,
    });
  };

  private deleteAvatarImage = () => {
    this.setState({
      fields: {
        ...this.state.fields,
        avatarId: undefined,
      },
    });
  };

  private handleInvalidElem = (e: HTMLElement): void => {
    if (e.dataset.index && +e.dataset.index !== this.state.tabIndex) {
      this.setState({ tabIndex: +e.dataset.index }, () => {
        e.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    } else {
      e.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  private handleChangeDisplayName = (value: string) => {
    const { companyName } = this.state.fields;
    const isCustomDisplayName = value !== '' && value !== `${companyName}`;
    this.setState({
      fields: {
        ...this.state.fields,
        displayName: value,
        customSupplier: value !== `${companyName}` ? true : false,
      },
      isCustomDisplayName,
    });
    if (this.props.handleChangeUniqueName) {
      this.props.handleChangeUniqueName();
    }
  };

  private handleChangeSameInformationCheckbox = (e: FormEvent<HTMLInputElement>) => {
    this.setState({ isSameOrderingInfo: e.currentTarget.checked }, () => {
      if (this.state.isSameOrderingInfo) {
        this.preFillFields(this.state.fields.billingAddress);
      }
    });
  };

  private preFillFields = (billingAddress: SuppliersModule.SupplierAdditionalContact): void => {
    billingAddress = billingAddressDefault();
    const updatedFields = {
      ...this.state.fields,
    };

    for (const key in updatedFields) {
      if (billingAddress.hasOwnProperty(key)) {
        billingAddress[key] = updatedFields[key];
      }
    }
    for (const key in updatedFields.shippingAddress) {
      if (billingAddress.hasOwnProperty(key) && billingAddress[key] === '') {
        billingAddress[key] = updatedFields.shippingAddress[key];
      }
    }
    if (updatedFields.companyName) {
      billingAddress.company = updatedFields.companyName;
    }
    updatedFields.billingAddress = billingAddress;
    this.setState({ fields: updatedFields });
  };

  private deleteAdditionalContact = (index: number): void => {
    const updateAdditionalContacts = this.state.fields.additionalContacts.filter(
      (_: any, i: any) => i !== index
    );

    this.setState({
      fields: {
        ...this.state.fields,
        additionalContacts: updateAdditionalContacts,
      },
    });
  };

  private handleKeyPressForm(e: KeyboardEvent<HTMLElement>) {
    if (e.which === 13 && (e.target as HTMLTextAreaElement).name !== 'notes') {
      e.preventDefault();
    }
  }

  private setAdditionalFormStatus = (status: 'open' | 'closed'): void => {
    this.setState({
      additionalFormOpen: status === 'open',
    });
  };
  updateParentState = () => {
    this.setState({ isOpen: false });
  };
}

function mapStateToProps(state: RootState, ownProps: AddSupplierProps): AddSupplierProps {
  return {
    ...ownProps,
    accountId: parseFloat(localStorage.getItem('accountId') || '0'),
  };
}

export default connect(mapStateToProps)(SupplierModal);
